import React, { useMemo } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { IBanner } from '~/src/api/content/banners';
import {
    CELL_SPACING_DATA,
    EMediaWidth,
    needCountCarousel,
    needCountCarouselLaptop,
    ONE_SLIDE,
    sDesktopMedia,
    TEST_NAMES_ATTR,
    TWO_SLIDES,
} from '~/src/features/equipment/pageBlocks/BannerRoutersCardBlock/constants';
import { useGaBanner } from '~/src/features/index/Banners/TopBanners/useGaBanner';

import { renderRouterCards } from './renderRouterCards';

import * as ST from './styled';

interface IProps {
    bannerWithRouters: IBanner,
}

export const BannerRoutersCardBlock = ({ bannerWithRouters }: IProps): JSX.Element | null => {
    const isSDesktopForCarousel = useMatchMedia(sDesktopMedia);
    const isSDesktop = useMatchMedia(EMediaWidth.sDesktop);
    const isLaptop = useMatchMedia(EMediaWidth.laptop);

    const {
        bannerInfo: { title, link, image_background, button_type, text_color, text, button_text },
        routers = [],
    } = bannerWithRouters;
    const routersCount = routers.length;

    const { onBannerClick } = useGaBanner('long', title, link);

    const needCarouselWrap = useMemo(() => {
        return (routersCount >= needCountCarousel) || (isLaptop && routersCount >= needCountCarouselLaptop);
    }, [isLaptop, routersCount]);

    const carouselCellSpacing = useMemo(() => isSDesktop ? CELL_SPACING_DATA.sDesktop : CELL_SPACING_DATA.desktop, [isSDesktop]);

    if (!routersCount) {
        return null;
    }

    return (
        <ST.Container
            needCarouselWrap={needCarouselWrap}
            backgroundImgPath={image_background}
            colorProp={text_color}
            data-test={TEST_NAMES_ATTR.container}
        >
            <ST.InfoBlock needCarouselWrap={needCarouselWrap}>
                <ST.Title data-test={TEST_NAMES_ATTR.title}>{title}</ST.Title>
                <ST.Text data-test={TEST_NAMES_ATTR.subTitle}>{text}</ST.Text>
                <Button
                    bType={button_type}
                    size={'medium'}
                    href={link}
                    onClick={onBannerClick}
                >
                    {button_text}
                </Button>
            </ST.InfoBlock>
                {needCarouselWrap
                    ? <ST.CardsBlock data-test={TEST_NAMES_ATTR.carousel}>
                            <NukaCarousel
                                cellSpacing={carouselCellSpacing}
                                slidesToShow={isSDesktopForCarousel ? TWO_SLIDES : ONE_SLIDE}
                                withoutArrows={true}
                                wrapAround={true}
                            >
                                {renderRouterCards(routers)}
                            </NukaCarousel>
                        </ST.CardsBlock>
                    : renderRouterCards(routers)
                }
        </ST.Container>
    );
};
